import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-the-j05-chat-screen-panel" }
const _hoisted_2 = {
  key: 0,
  class: "p-the-j05-chat-screen-panel__notifications"
}
const _hoisted_3 = {
  key: 0,
  class: "p-the-j05-chat-screen-panel__notifications__item p-the-j05-chat-screen-panel__date"
}
const _hoisted_4 = { class: "p-the-j05-chat-screen-panel__date__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheJ05NotificationPanelThanks = _resolveComponent("TheJ05NotificationPanelThanks")!
  const _component_J05ChatScreenPanelMessageBody = _resolveComponent("J05ChatScreenPanelMessageBody")!
  const _component_J05ChatScreenPanelMessage = _resolveComponent("J05ChatScreenPanelMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.shownDate || _ctx.shownUnreadLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.shownDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.date), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_J05ChatScreenPanelMessage, {
      class: "p-the-j05-chat-screen-panel__message",
      "chat-data": _ctx.chatData,
      "is-sp": _ctx.isSp,
      "is-you-sent": _ctx.isYouSent,
      "class-name-direction": _ctx.classNameDirection,
      "partner-user-image": _ctx.partnerUserImage
    }, {
      content: _withCtx(() => [
        (_ctx.isThanksMessage)
          ? (_openBlock(), _createBlock(_component_TheJ05NotificationPanelThanks, {
              key: 0,
              title: _ctx.title,
              point: _ctx.point,
              message: _ctx.message,
              "badge-icon": _ctx.badgeIcon,
              "badge-name": _ctx.badgeName,
              "is-you-sent": _ctx.isYouSent
            }, null, 8, ["title", "point", "message", "badge-icon", "badge-name", "is-you-sent"]))
          : (_ctx.message)
            ? (_openBlock(), _createBlock(_component_J05ChatScreenPanelMessageBody, {
                key: 1,
                "message-data": { message: _ctx.message },
                "is-you-sent": _ctx.isYouSent,
                "class-name-direction": _ctx.classNameDirection
              }, null, 8, ["message-data", "is-you-sent", "class-name-direction"]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["chat-data", "is-sp", "is-you-sent", "class-name-direction", "partner-user-image"])
  ]))
}